import React from "react";
import { Route, Routes } from "react-router-dom";
import { IMAGES } from "../constants/images";

import { Login } from "../pages/autenticacao/login";
import { RecuperacaoSenha } from "../pages/autenticacao/recuperacaoSenha";
import { RecuperacaoSenhaSucesso } from "../pages/autenticacao/recuperacaoSenhaSucesso";
import { ContentLayout } from "../components/contentLayout/contentLayout";

const styles = {
  containerCadastro: {
    backgroundImage: `url(${IMAGES.backgroundCadastro})`,
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
  },
};

const PublicRoutes = () => {
  return (
    <ContentLayout style={styles?.containerCadastro}>
      <Routes>
        <Route path="/recuperacao-senha" element={<RecuperacaoSenha />} />
        <Route path="/recuperacao-senha-sucesso" element={<RecuperacaoSenhaSucesso />} />
        <Route path="*" element={<Login />} />
      </Routes>
    </ContentLayout>
  );
};

export { PublicRoutes };
